<template>
  <v-btn-toggle :value="value" @change="$emit('input', $event)" mandatory>
    <v-btn
      v-for="button in buttons"
      :key="button.value"
      :value="button.value"
      small
      text
      active-class="active-mode"
      :disabled="button.disabled"
    >
      {{ button.text }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: "AppToggleButtons",

  props: {
    /**
     * Button that is selected
     */
    value: {
      type: String,
      required: true
    },

    /**
     * List of buttons
     */
    buttons: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.active-mode {
  color: whitesmoke !important;
  background: var(--primary-highlight);
}
</style>



// WEBPACK FOOTER //
// src/components/_Atoms/AppToggleButtons.vue